import React from 'react';
import PropTypes from 'prop-types';
import Icon, { IconType } from '../icon/icon';
import './badge.scss';

/**
 * Badge with optional icon. It can be used to list items or to define tags.
 */
const Badge = (props) => {
  const {
    children, icon, onClick, className,id,disabled
  } = props;
  return (
    <button disabled={disabled?disabled:false} type="button" id={id} onClick={onClick} className={`${className} badge badge-secondary border-0`}>
      <span className="badge-element">{children}</span>
      { icon !== null
      && (
      <Icon
        icon={icon}
      />
      )}
    </button>
  );
};

Badge.propTypes = {
  /**
   * Text inside the badge
   */
  children: PropTypes.node,
  /**
   * To select a icon inside the badge
   */
  icon: PropTypes.oneOf(Object.values(IconType)),
  /**
   * Function to bind onClick HTML functionality
   */
  onClick: PropTypes.func,
  className: PropTypes.string,
};

Badge.defaultProps = {
  children: '',
  icon: null,
  onClick: () => {},
  className: '',
};

export default Badge;
